import { graphql } from '@/gql';

export const SubmitPerformanceBmpResultsMutation = graphql(`
    mutation SubmitPerformanceBmpResults($input: SubmitBmpResultInput!) {
        submitBmpResult(input: $input) {
            ... on SubmitBmpResultSuccessfulResponse {
                result {
                    ...BmpAssessmentResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const _BmpAssessmentResult = graphql(`
    fragment BmpAssessmentResult on PerformanceResult {
        id
        companyId
        company {
            id
            name
        }
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        isTiedToAssessmentRun
        assessmentRunId
        assessmentRun {
            name
        }
        result {
            __typename
            ... on BmpResult {
                ...BmpAssessmentResultData
            }
        }
        createdAt
        completedAt
        updatedAt
        updatedBy
        isDeleted
    }
`);

const _BmpAssessmentResultData = graphql(`
    fragment BmpAssessmentResultData on BmpResult {
        percentage
    }
`);
